/**
 * Created by greg on 12/07/2018.
 */
import { inject, Injectable, OnDestroy } from '@angular/core';
import { lastValueFrom, merge, Subject, take, takeUntil } from 'rxjs';
import { EventStreamChange} from '../models/$event.model';
import { ErrorStreamChange} from '../models/$error.model';
import { User } from '../../../globals/store/user.data';
import { getBlankUser, userActions } from '../store/user.era';
import { AuthService } from './auth.service';
import { Router, ActivatedRoute } from "@angular/router";
import { LogService } from "./log.service";
import { Store, select } from '@ngrx/store';
import { JoiUser, UserSettings } from '../../../globals/store/user.data';
import { nameJoiner } from '../helpers/helpers';
import { doc, Firestore, setDoc, updateDoc } from '@angular/fire/firestore';
import { userFeature } from '../store/user.era';
import { settingsActions, settingsFeature } from '../store/settings.era';


@Injectable({ providedIn: 'root'})
export class UserService implements OnDestroy {

  get uid():string { return this._uid };
  get email():string { return this._email };
  get firstName():string { return this._firstName };
  get lastName():string { return this._lastName };
  get photoURL():string { return this._photoURL };
  get displayName():string { return this._displayName };
  get fullName(): string { return nameJoiner({ firstName: this._firstName, lastName: this._lastName }) }
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private _uid = '';// change to null after cleaned code of old one
  private _email = '';
  private _firstName = '';
  private _lastName = '';
  private _photoURL = '';
  private _displayName = '';
  public user_is_set = false;
  private blankUser:User = getBlankUser();
  public loggedOut$:Subject<boolean> = new Subject()
  private db = inject(Firestore);

  public $events: Subject<EventStreamChange> = new Subject();
  public $errors: Subject<ErrorStreamChange> = new Subject();

  constructor(private auth: AuthService, private route: ActivatedRoute, private router:Router, private log:LogService, public store: Store
  ) {
    this.store.select(userFeature.selectUser).pipe(takeUntil(this.destroy$)).subscribe(user => {
      this._uid = user ? user.uid : '';
      this._email = user ? user.email : '';
      this._firstName = user ? user.firstName : '';
      this._lastName = user ? user.lastName : '';
      this._photoURL = user ? user.photoURL : '';
      this._displayName = user ? user.displayName : '';
    })
    this.auth.currentUserData$.subscribe(user=>{
      if(user){
        if(this._uid === user.uid) {
          this.store.dispatch(userActions.modifyUser(user))
          this.store.dispatch(settingsActions.updateUserSettings(user.settings))
        } else{
          this.store.dispatch(userActions.loaded(user))
        }
      }else{
        // this.loggedOut$.next(true)
      }
    })
  }

  async updateSettings(partialSettings: Partial<UserSettings>) {
    const oldSettings = await lastValueFrom(this.store.select(settingsFeature.selectUser).pipe(take(1)))
    const settings = { ...oldSettings, ...partialSettings }
    const ref = doc(this.db, `users/${this._uid}`)
    updateDoc(ref, 'settings', settings)
  }

  
  getHomepage(user?: User) { // should be moved to settings
      const u = user ? user : this.blankUser;
      const homepage = u && u.settings && u.settings.last_visited_page ? u.settings.last_visited_page : '/home';
      return homepage;
  }
  signOut() {
    console.log('signOut being called from user service')
    this.loggedOut$.next(true)
    this.auth.signOut();
  }

  async updateUser(userUpdate: Partial<JoiUser>, notify_hubspot:boolean, log_data: Partial<ErrorStreamChange>) {
    // NO IDEA WHY THIS WAS PUT INTO THE STORE.  Had to move here to get rid of a new circular dependency.  Kept the store changes the same in case it was used

    this.store.dispatch(userActions.updateUser(this.uid, userUpdate ))
    const ref = doc(this.db, `users/${this.uid}`)
    console.log("Should be updating user with changes: ", userUpdate)
    try {
      await updateDoc(ref, userUpdate)
      console.log("here is where users are updated in HS notify_hubspot:"+notify_hubspot)
      if (notify_hubspot) this.log.hsProfileUpdate(userUpdate)
      this.store.dispatch(userActions.success())
    } catch(response) {
      this.log.error({
        response,
        data: userUpdate,
        error: new Error,
        message: 'There was an error updating your user record',
        ...log_data
      }) // After copying this over from user.era, I realize there is no handling in the store for an error, just a continued loading status
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
